import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, FORM_FIELDS_TYPES, LOEWE_IMAGE_UPLOAD_FIELD_PROPS } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { getFormStrucWithoutComponentTable, mapindexbyPath } from 'src/utils/formStruc';
import { addIndexToPath, checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getTextFieldValidationByDatei } from 'src/lib/validation/fieldValidationHelper';
const P = AntragSchema.attributes;

const EffekteDesVorhabensAntragLoewe: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default EffekteDesVorhabensAntragLoewe;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Alleinstellungsmerkmale, maxCharLength: 5000 },
				{ ...P.Projektbeschreibung_Loewe.schema.attributes.Wissenstransfer_Forschung_Und_Lehre, maxCharLength: 5000 },
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Staerkung_Hochschule_Forschungseinrichtung,
					maxCharLength: 5000,
					label: 'Beitrag zur Stärkung der Hochschule / Forschungseinrichtung (u.a. Aufbau neuer Forschungsschwerpunkte, Transferaktivitäten, Abschlussarbeiten, Promotionen, etc. …)',
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const customFormStruc = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.schema.attributes.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.schema.attributes.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.schema.attributes.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};

export const getFormStrucEffekteDesVorhabensAntragLoewe = (application: any) => {
	let result: FormStrucItem[] = [];
	const bilderLength = get(application, P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder.path, []).length;

	//check if there are images, if yes then validate the additional fields for each image
	for (let i = 0; i < bilderLength; i++) {
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStruc(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Wissenschaftliche_Effekte_Bilder,
		);
		result = concat(result, customFormStrucWithIndex);
	}
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Pruefstatus.path,
			P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Effekte_Erledigt.path,
		)
	) {
		result = concat(result, formStrucPruefAssistenz());
	}
	//concat with default formstruc without componentTable, or else componentTable path will overwrite customFormStruc validation
	result = concat(result, getFormStrucWithoutComponentTable(formStruc()));

	return result;
};
